import apiRequest, { apiUpload } from './client';

// Facturation cote company (popover Compte > Facturation mensuelle) — lecture
// seule de SES PROPRES factures (billing/views.py:CompanyInvoiceListView).
// Distinct de api/billing.js (superadmin, genere/modifie les factures de
// toutes les companies).

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

// `date` (YYYY-MM-DD) optionnel : ne renvoie que la facture dont la periode
// couvre cette date. Sans date, renvoie tout l'historique de la company.
export const searchMyInvoices = (date) => apiRequest(`/billing/my-invoices/${toQuery({ date })}`);

// Widget "Online Payment" du dashboard (OnlinePaymentWidget.jsx) : derniere
// facture + solde total du (toutes factures confondues, donc inclut une
// dette d'une periode passee).
export const fetchMyBillingSummary = () => apiRequest('/billing/my-summary/');

// Page "Pay Online" (PaymentInvoicePage.jsx) — historique de SES PROPRES
// justificatifs de paiement deposes + depot d'un nouveau (recu photo/PDF).
export const fetchMyPaymentSubmissions = () => apiRequest('/billing/payment-submissions/');

export const submitPaymentProof = (formData) =>
  apiUpload('/billing/payment-submissions/', formData, { method: 'POST' });
